export const LOG_TREATMENT_RESULT_DEFAULT = false;
//# sourceMappingURL=split.constants.js.map